import React, { Component } from 'react';
import {Grid, Row, Col } from 'react-bootstrap';
import Git from 'react-icons/lib/fa/github'
import Twitter from 'react-icons/lib/fa/twitter'
import '../style.css'

class Contact extends Component {
  render() {
    return (
      <Grid className="container-fluid" id="section3">
      <h1 id='portID'>Feel free to message me on Twitter, follow me on GitHub...or both!</h1>
      <Row>
        <Col sm={6} id="icon1">
          <a href='https://github.com/LukeHendrick'><Twitter /></a>
        </Col>
        <Col sm={6} id="icon2">
          <a href='https://twitter.com/lukehendrick521'><Git /></a>
        </Col>
      </Row>
    </Grid>
    )
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact.js